
import jsPDF from 'jspdf';

export const wrapText = (pdf: jsPDF, text: string, maxWidth: number, fontSize: number): string[] => {
  pdf.setFontSize(fontSize);
  return pdf.splitTextToSize(text, maxWidth);
};

export const cleanContentForPDF = (content: string): string => {
  if (!content || typeof content !== 'string') return 'Conteúdo não disponível';
  
  return content
    .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold markers
    .replace(/\*(.*?)\*/g, '$1') // Remove italic markers
    .replace(/\n\s*\n/g, '\n') // Remove extra line breaks
    .trim();
};

export const checkNewPage = (
  pdf: jsPDF, 
  yPosition: number, 
  requiredHeight: number, 
  pageHeight: number, 
  margin: number
): { needsNewPage: boolean; newYPosition: number } => {
  if (yPosition + requiredHeight > pageHeight - margin) {
    pdf.addPage();
    return { needsNewPage: true, newYPosition: margin };
  }
  return { needsNewPage: false, newYPosition: yPosition };
};
